import React from "react";
import * as AlfredoStyles from "../../../styles/global/global";
import * as AlfredoComponents from "../../../components";

const CashReport: React.FC = () => {
  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.CashReport />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default CashReport;
